import axios from '@/axios.js';

export default {
  methods: {
    checkUserAdultRedirect(isAdult, harmonySlug) {
      if (!isAdult) {
        return false;
      }

      const storageKey = `adult_verified_${harmonySlug}`;
      const urlParams = new URLSearchParams(window.location.search);
      const userAgent = navigator.userAgent.toLowerCase();

      // Detectar si viene de Instagram, Facebook o TikTok - siempre redirigir
      const utmSource = urlParams.has('utm_source');
      const hasFbclid = urlParams.has('fbclid');
      const isFromTikTok = userAgent.includes('tiktok') ||
        userAgent.includes('bytedance') ||
        userAgent.includes('musical_ly');

      if (utmSource || hasFbclid || isFromTikTok) {
        // Siempre redirigir, sin importar el storage
        window.location.href = `https://hrm.fan/${harmonySlug}`;
        return true;
      }

      // Verificar si llega el parámetro ?ref=true en la URL
      const refParam = urlParams.get('ref');

      if (refParam === 'true') {
        // El usuario ya confirmó que es adulto, crear storage y permitir acceso
        const adultData = {
          harmony: harmonySlug,
          isAdult: true,
          verifiedAt: new Date().toISOString()
        };
        localStorage.setItem(storageKey, JSON.stringify(adultData));
        this.is_user_adult = true;
        return false;
      }

      // Verificar si ya existe la verificación en localStorage
      const existingData = localStorage.getItem(storageKey);

      if (existingData) {
        try {
          const data = JSON.parse(existingData);
          if (data.isAdult) {
            this.is_user_adult = true;
            return false;
          }
        } catch (error) {
          // Si hay error al parsear, eliminar el dato corrupto
          localStorage.removeItem(storageKey);
        }
      }

      // Si es contenido para adultos y no hay verificación válida, redirigir
      window.location.href = `https://hrm.fan/${harmonySlug}`;
      return true;
    },

    async getPlatformsAdult() {
      try {
        const response = await axios.get('get-platforms-adult');
        this.platformsAdult = response.data;
      } catch (error) {
        console.log(error)
      }
    }
  }
}
